<template>
    <div class="customer-detail-info">
        <el-table border :data="customerInfo">
            <el-table-column label="基本信息">
                <template slot="header" slot-scope="scope">
                    <span>基本信息</span>
                    <el-button type="danger" size="mini" class="header-btn" @click="customerUserPhoneSubmit">保存</el-button>
                </template>
                <template slot-scope="scope">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form :model="scope.row" class="demo-form-inline" label-width="80px" size="mini">
                                <el-form-item label="昵称">
                                    <el-input v-model="scope.row.nickName" placeholder="无" :disabled="true"></el-input>
                                </el-form-item>
                                <el-form-item label="真实姓名">
                                    <el-input v-model="scope.row.trueName" placeholder="无" :disabled="true"></el-input>
                                </el-form-item>
                                <el-form-item label="登录名">
                                    <el-input v-model="scope.row.loginName" placeholder="无" :disabled="true"></el-input>
                                </el-form-item>

                            </el-form>
                        </el-col>
                        <el-col :span="8">
                            <el-form :model="scope.row" class="demo-form-inline" label-width="70px" size="mini">
                                <el-form-item label="性别">
                                    <el-input v-model="scope.row.gender==2?'女':'男'" placeholder="无" :disabled="true"></el-input>
                                </el-form-item>
                                <el-form-item label="* 手机" class="red">
                                    <el-input v-model="scope.row.mobile" placeholder="无" type="number" maxlength="11"></el-input>
                                </el-form-item>
                                <el-form-item label="所属地">
                                    <el-input v-model="scope.row.country+scope.row.province+scope.row.city" placeholder="无" :disabled="true"></el-input>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="8">
                            <el-form :model="scope.row" class="demo-form-inline" label-width="70px" size="mini">
                                <el-form-item label="级别">
                                    <el-input value="普通会员" placeholder="无" :disabled="true"></el-input>
                                </el-form-item>
                                <el-form-item label="来源">
                                    <el-input value="乐纯" placeholder="无" :disabled="true"></el-input>

                                </el-form-item>
                                <el-form-item label="渠道">
                                    <el-input value="微信商城" placeholder="无" :disabled="true"></el-input>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-form label-width="80px" size="mini">
                        <el-form-item label="OPENID">
                            <el-input v-model="scope.row.channelCustomerId" placeholder="无" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="COOKIT">
                            <el-input v-model="scope.row.sign" placeholder="无" :disabled="true"></el-input>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
        </el-table>
        <el-table border :data="customerVipInfo">
            <el-table-column label="会员信息">
                <template slot="header" slot-scope="scope">
                    <span>会员信息</span>
                    <el-button type="warning" size="mini" class="header-btn" @click="updateCustomerVipCache">清除会员缓存</el-button>
                </template>
                <template slot-scope="scope">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form :model="scope.row" class="demo-form-inline" label-width="80px" size="mini">
                                <el-form-item label="订单数">
                                    <el-input v-model="scope.row.ORDER_COUNT" placeholder="无" :disabled="true"></el-input>
                                </el-form-item>
                                <el-form-item label="修改等级">
                                    <el-select v-model="scope.row.CURRENT_LEVEL" placeholder="请选择" @change="updateCustomerVipLevel">
                                        <el-option
                                                v-for="item in levels"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                            </el-form>
                        </el-col>
                        <el-col :span="12">
                            <el-form :model="scope.row" class="demo-form-inline" label-width="70px" size="mini">
                                <el-form-item label="当前等级">
                                    <el-input v-model="scope.row.CURRENT_LEVEL" placeholder="无" :disabled="true"></el-input>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
        </el-table>
        <el-table border :data="isFollowList" :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="来源" width="80">
                <template slot-scope="scope">
                    {{scope.row.source==2?'小程序':'公众号'}}
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            <el-table-column label="是否关注" width="100">
                <template slot-scope="scope">
                    {{scope.row.subscribe==1?'已关注':'未关注'}}
                </template>
            </el-table-column>
            <el-table-column prop="subscribeTime" label="关注时间"></el-table-column>
            <el-table-column prop="unSubscribeTime" label="取关时间"></el-table-column>
            <el-table-column prop="openId" label="OPENID"></el-table-column>

        </el-table>
    </div>
</template>
<script>
    import {getCustomerInfo,getCustomerFollowInfo,customerPhoneSubmit,customerVipCenterInfo,updateCustomerVipCenterLevel,updateCustomerVipCenterCache} from '@/api/api'
    export default{
        data(){
            return {
                customerInfo:[{}],
                customerVipInfo:[{}],
                isFollowList:[],
                customerId:this.$route.params.id,
                levels:[
                    {value:1,label:'1级会员'},
                    {value:2,label:'2级会员'},
                    {value:3,label:'3级会员'},
                    {value:4,label:'4级会员'},
                    {value:5,label:'5级会员'},
                    {value:6,label:'6级会员'},
                    {value:7,label:'7级会员'},
                    {value:0,label:'普通用户'},
                ]
            }
        },
        mounted(){
            this.getUserInfo()
            this.getUserFollowInfo()
        },
        methods:{
            returnHistory(){
                window.history.go(-1)
            },
            getUserInfo(){
                getCustomerInfo({customerId:this.customerId}).then(res=>{
                    this.customerInfo = [res.data.value]
                })
                customerVipCenterInfo({customerId:this.customerId}).then(res=>{
                    this.customerVipInfo = [res.data.value]
                })
            },
            getUserFollowInfo(){
                getCustomerFollowInfo({customerId:this.customerId}).then(res=>{
                    this.isFollowList = res.data.value
                })
            },
            customerUserPhoneSubmit(){
                if(this.customerInfo[0].mobile.length!=11){
                    this.$notify({
                        title: '警告',
                        message: '请输入正确的手机号',
                        type: 'warning'
                    });
                    return false
                }
                customerPhoneSubmit({customerId:this.customerId,mobile:this.customerInfo[0].mobile}).then(res=>{
                    console.log(res)
                    if(res.data.status==200){
                        this.$notify({
                            title: '成功',
                            message: '手机号保存成功',
                            type: 'success'
                        });
                    }else{
                        this.$notify.error({
                            title: '错误',
                            message: res.data.message,
                        });
                    }
                })
            },
            updateCustomerVipCache(){
                updateCustomerVipCenterCache({customerId:this.customerId}).then(res=>{
                    console.log(res)
                    if(res.data.status==200){
                        this.$notify({
                            title: '成功',
                            message: '清除缓存成功',
                            type: 'success'
                        });
                    }else{
                        this.$notify.error({
                            title: '错误',
                            message: res.data.message,
                        });
                    }
                })
            },
            updateCustomerVipLevel(val){
                updateCustomerVipCenterLevel({customerId:this.customerId,level:val}).then(res=>{
                    console.log(res)
                    if(res.data.status==200){
                        this.$notify({
                            title: '成功',
                            message: '修改成功',
                            type: 'success'
                        });
                    }else{
                        this.$notify.error({
                            title: '错误',
                            message: res.data.message,
                        });
                    }
                })
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">

    .customer-detail-info{
        .el-input.is-disabled .el-input__inner{
            color: #8c8c8c;
        }
        .red .el-form-item__label{
            color: red;
        }
        .header-btn{
            float: right;
        }
        .el-select{
            width: 100%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/userSystem/customerInfo.vue